import enterView from 'enter-view';
import imagesLoaded from 'imagesloaded';

export const tabletBP = 800;
export const touchMoveClasses = 'touchmove  pointermove  MSPointerMove';
export let winW = window.innerWidth;
export let browserDetection = {};
export let stateObj = {
    time: Date.now(),
};

let winResizeThrottle;

export function getScrollTop() {
    const supportPageOffset = window.pageXOffset !== undefined,
        isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';

    return supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop;
}

export function getClosest( elem, selector ) {

	// Element.matches() polyfill
	if (!Element.prototype.matches) {
		Element.prototype.matches =
			Element.prototype.matchesSelector ||
			Element.prototype.mozMatchesSelector ||
			Element.prototype.msMatchesSelector ||
			Element.prototype.oMatchesSelector ||
			Element.prototype.webkitMatchesSelector ||
			function(s) {
				var matches = (this.document || this.ownerDocument).querySelectorAll(s),
					i = matches.length;
				while (--i >= 0 && matches.item(i) !== this) {}
				return i > -1;
			};
	}

	// Get closest match
	for ( ; elem && elem !== document; elem = elem.parentNode ) {
		if ( elem.matches( selector ) ) return elem;
	}

	return null;

};

export function animateInViewEls(selector, inViewClass, offset) {
    enterView({
        selector: selector,
        offset: offset,
        once: true,
        enter: el => {
            if (el.dataset.watchdelay) {
                // Add class after delay period
                setTimeout(() => {
                    el.classList.add(inViewClass);
                }, parseFloat(el.dataset.watchdelay));
            } else {
                // Add class immediately
                el.classList.add(inViewClass);
            }
        },
    });
}

export function slideDown(el) {
    el.style.display = 'none';
}

export function scrollToTarget(selector, offsetY = 0) {
    const triggers = document.querySelectorAll(selector);
    const body = document.body;

    triggers.forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            // Get the target elements
            const targetEl = document.querySelector(el.dataset.target),
                targetElOffsetTop = targetEl.offsetTop;

            console.log(targetEl);

            // Open the section, if necessary
            let targetHeading = targetEl.querySelectorAll('h2.numbered'),
                targetSection = targetEl.querySelectorAll('.expandable-subsection');

            if(targetHeading[0].classList.contains('closed')) {

                targetHeading[0].classList.remove('closed');
                targetSection[0].classList.add('expanded');

              }

            window.scroll({
                top: targetElOffsetTop - offsetY,
                left: 0,
                behavior: 'smooth',
            });

        });
    });
}

export function autoScrollToTarget(selector, offsetY = 0) {
    // Get the target element
    const targetEl = document.querySelector(selector),
        targetElOffsetTop = targetEl.offsetTop;

    window.scroll({
        top: targetElOffsetTop - offsetY,
        left: 0,
        behavior: 'smooth',
    });
}

export function searchForImages($page) {
  var $containers = $page.querySelectorAll('.wp-block-image');
    for (var i = 0; i < $containers.length; i++) {
      loadImage($containers[i]);
    }
}

function loadImage($container) {
  imagesLoaded($container, () => {
			let imgs = $container.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].classList.add('loaded');
      }
	});
}

function runCookies() {
    const container = document.querySelector('.js-cookies-notice'),
    close = document.querySelector('.js-cookies-notice-close');

  // Do we have a cookie set to prevent this notice showing?
  if (
      !document.cookie.split(';').filter(function(item) {
          return item.indexOf('cookiesnotice=') >= 0;
      }).length
  ) {
      // Cookie doesn't exist
      // Show the notice
      setTimeout(() => {
        container.classList.add('show');
      }, 2000);

      // Clicking on the close link hides the cookies notice and sets a cookie to cause it not to show in the future
      close.addEventListener('click', () => {
          var d = new Date();

          // Hide notice
          container.classList.remove('show');

          d.setTime(d.getTime() + 182.5 * 24 * 60 * 60 * 1000); // ~ 6 months from now

          // Set the cookie
          document.cookie = 'cookiesnotice=1; expires=' + d.toUTCString() + '; path=/';
      });
  }

}

export function buildPage() {
    const content = document.querySelector('.js-content');

    searchForImages(content);

    showPage();

    runCookies();
}

export function showPage() {
    const body = document.querySelector('body');

    body.classList.add('page-ready');

    // Auto scroll to results on search results page
    if (document.querySelector('.js-search-results')) {
        setTimeout(() => {
            autoScrollToTarget('.js-search-results', 30);
        }, 1000);
    }

    // Run timing function to watch for elements that have
    // animations to run when within the viewport
    // body.addEventListener('transitionend', Utilities.buildTimingFunctions);
    setTimeout(function() {
        body.classList.add('hide-loader');
        animateInViewEls('.js-watch', 'in-view', 0.2);
    }, 700);
}

export function unloadPage(goTo) {
    const body = document.querySelector('body');

    body.classList.add('page-unload');

    setTimeout(() => {
        window.location = goTo;
    }, 500); // should equal page-unload CSS transition time
}

export function browserCheck() {
    var nUA = navigator.userAgent;

    // If this is an iOS device
    if (/(iPad|iPhone|iPod)/g.test(nUA)) {
        browserDetection.iOS = {};
    }

    if (/(Windows Phone|iemobile|WPDesktop)/gi.test(nUA)) {
        browserDetection.ieMobile = {};
    }

    if (/Safari/.test(nUA)) {
        browserDetection.safari = {};
    }

    if (/Trident/.test(nUA)) {
        browserDetection.ie = {};
    }

    if (/Edge/.test(nUA)) {
        browserDetection.edge = {};
    }

}

export function isTouchDevice() {
    return document.documentElement.classList.contains('touchevents');
}

export function findParentByTagName(el, tagName) {
    let parent = el;

    while (parent !== null && parent.tagName !== tagName.toUpperCase()) {
        parent = parent.parentNode;
    }

    return parent;
}

export function matches(el, selector) {
    let matches =
        document.documentElement.matchesSelector ||
        document.documentElement.webkitMatchesSelector ||
        document.documentElement.mozMatchesSelector ||
        document.documentElement.oMatchesSelector ||
        document.documentElement.msMatchesSelector;

    if (!matches.call(el, selector)) {
        return false;
    }

    return true;
}

export function trackAnchorClicks() {
    /**
     * Internal Links click & page unloading
     **/
    document.addEventListener('click', e => {
        // Get the closest parent anchor element
        let el = findParentByTagName(e.target, 'A');

        // No anchor parent found...
        if (
            typeof el === 'undefined' ||
            el === null ||
            el.tagName !== 'A' ||
            typeof el.href === 'undefined' ||
            el.href === '' ||
            el.href.indexOf('#') > -1 ||
            el.classList.contains('js-prevent-page-unload')
        ) {
            return;
        }

        // Only run unload if we're not using a modifier key like cmd/ctrol or shift as well
        if (e.shiftKey || e.ctrlKey || e.metaKey) {
            return;
        }

        // If the anchor has the target property set don't run unload
        if (typeof el.getAttribute('target') !== "undefined" && el.getAttribute('target') === '_blank') {
            return;
        }

        // Check that link is internal to site
        if (window.location.hostname === el.hostname) {
            e.preventDefault();

            // Check if this anchor's uri matches a pattern
            // from one of the items in AppPages.pathSegmentMatches
            let uri = el.pathname,
                match = false;

            for (let i = 0; i < AppPages.pathSegmentMatches.length; i++) {
                if (AppPages.pathSegmentMatches[i].test(uri)) {
                    match = true;
                }
            }

            if (match && !browserDetection.ie) {
                // Save existing url to previousUrl
                AppPages.previousUrls.push(window.location.href);

                // Push it
                window.history.pushState(stateObj, null, el.href);

                // Track it in GA
                if (typeof ga !== 'undefined') {
                  ga("send", "pageview", el.href);
                }

                // Load the page contents
                AppPages.loadPage(el.href);

                return;
            }

            // Normal anchor link to different page
            unloadPage(el.href);
        }
    });
}

export function stringToHTML(str) {
    // If DOMParser is supported, use it
    if (parserSupport()) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(str, 'text/html');
        return doc.body;
    }

    // Otherwise, fallback to old-school method
    var dom = document.createElement('div');
    dom.innerHTML = str;
    return dom;
}

function parserSupport() {
    if (!window.DOMParser) {
        return false;
    }

    var parser = new DOMParser();

    try {
        parser.parseFromString('x', 'text/html');
    } catch (err) {
        return false;
    }

    return true;
}

function windowResize() {
    winW = window.innerWidth;
}

window.addEventListener('resize', () => {
    clearTimeout(winResizeThrottle);

    winResizeThrottle = setTimeout(windowResize, 150);
});
